import { DASHBOARD_TYPE } from "./enums";

export type DashboardOwner = "buyer" | "seller" | "shared";

// Buyer-only screens inside /dashboard. The match is "exact path or any
// nested path", so "/dashboard/review" covers "/dashboard/review/:adId".
const BUYER_PATHS = [
  "/dashboard/watchlist",
  "/dashboard/bids",
  "/dashboard/buyer-payments",
  "/dashboard/reviews",
  "/dashboard/following",
  "/dashboard/review",
];

// Seller-only screens inside /dashboard.
const SELLER_PATHS = [
  "/dashboard/listing",
  "/dashboard/create",
  "/dashboard/update",
  "/dashboard/preview",
  "/dashboard/update-preview",
  "/dashboard/open-for-bids",
  "/dashboard/disputes",
  "/dashboard/seller-payments",
  "/dashboard/my-reviews",
  "/dashboard/followers",
  "/dashboard/trustap-account",
  "/dashboard/trustap-account-callback",
];

const matches = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(prefix + "/");

// Returns which dashboard "owns" a given path. `shared` means the route
// is rendered identically for buyer and seller (e.g. /dashboard home,
// profile, help) and should NOT trigger a dashboard switch — the user's
// previous mode is preserved on those screens.
export const getDashboardForPath = (pathname: string): DashboardOwner => {
  if (BUYER_PATHS.some((p) => matches(pathname, p))) return DASHBOARD_TYPE.BUYER as DashboardOwner;
  if (SELLER_PATHS.some((p) => matches(pathname, p))) return DASHBOARD_TYPE.SELLER as DashboardOwner;
  return "shared";
};
